import { GraphSnapshot } from 'dashboard/models/graph-snapshot';
import Action from 'lib/interfaces/Action';

export enum GraphSnapshotActionType {
  SetGraphSnapshot = 'graph/SET_GRAPH_SNAPSHOT',
  ClearGraphSnapshot = 'graph/CLEAR_GRAPH_SNAPSHOT',
}

interface GraphSnapshotPayload {
  graphSnapshot: GraphSnapshot;
}

export type GraphSnapshotActions =
  | Action<GraphSnapshotActionType.SetGraphSnapshot, GraphSnapshotPayload>
  | Action<GraphSnapshotActionType.ClearGraphSnapshot, {}>;

export function setGraphSnapshot(
  graphSnapshot: GraphSnapshot,
): Action<GraphSnapshotActionType.SetGraphSnapshot, GraphSnapshotPayload> {
  return {
    type: GraphSnapshotActionType.SetGraphSnapshot,
    payload: { graphSnapshot },
  };
}

export function clearGraphSnapshot(): Action<GraphSnapshotActionType.ClearGraphSnapshot, {}> {
  return {
    type: GraphSnapshotActionType.ClearGraphSnapshot,
    payload: {},
  };
}
